/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for an autograding job
 */
export interface AutogradeJobParams {
  courseId: string;
  moduleId: string;
  userId: string;
  preserveExistingEvaluations?: boolean;
}
